export const EmailConstants = {
  DefaultMaxSubjectSize: 100,
  DefaultMaxBodySize: 4000
};